export const formatRelativeTime = (value, options = {}) => {
  const { fallback = "Just now" } = options;
  if (!value) return fallback;

  const target = new Date(value);
  if (Number.isNaN(target.getTime())) return fallback;

  const diffMinutes = Math.round((target.getTime() - Date.now()) / 60000);
  if (Math.abs(diffMinutes) < 1) return fallback;

  const thresholds = [
    { unit: "year", value: 60 * 24 * 365 },
    { unit: "month", value: 60 * 24 * 30 },
    { unit: "day", value: 60 * 24 },
    { unit: "hour", value: 60 },
    { unit: "minute", value: 1 },
  ];

  const rtf = new Intl.RelativeTimeFormat(undefined, { numeric: "auto" });
  for (const { unit, value } of thresholds) {
    if (Math.abs(diffMinutes) >= value || unit === "minute") {
      const delta = Math.round(diffMinutes / value);
      return rtf.format(delta, unit);
    }
  }

  return fallback;
};
